/* <rr-stack-ladder> — el programa de stack en ficha y colección: al añadir o cambiar
   cantidades del carrito, marca el tramo, mueve la barra y cambia el mensaje sin
   recargar. Los textos llegan ya traducidos del Liquid (data-msg-0…4, y data-msg-max
   con __N__ para 5 o más); los % salen de los ajustes del theme. En el carrito no hace
   falta: allí el Liquid se re-renderiza entero. Sin dependencias. */
(() => {
  if (customElements.get('rr-stack-ladder')) return;

  const pieces = (cart) =>
    cart && Array.isArray(cart.items)
      ? cart.items.reduce((n, item) => n + (item.gift_card ? 0 : item.quantity), 0)
      : null;

  class RRStackLadder extends HTMLElement {
    connectedCallback() {
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        this.tiers = [];
      }
      this.onCart = (e) => {
        const n = pieces(e.detail && e.detail.cart);
        if (n !== null) this.render(n);
      };
      document.addEventListener('rr:cart-updated', this.onCart);
      document.addEventListener('rr:cart-changed', this.onCart);
      // el ticker de colección se para y sigue al tocarlo (con ratón ya se para al pasar)
      if (this.classList.contains('rr-ladder--strip')) {
        this.addEventListener('click', () => this.classList.toggle('is-paused'));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('rr:cart-updated', this.onCart);
      document.removeEventListener('rr:cart-changed', this.onCart);
    }

    render(n) {
      const top = this.tiers.length ? this.tiers[this.tiers.length - 1][0] : 4;
      let current = 0;
      this.tiers.forEach(([qty]) => {
        if (n >= qty) current = qty;
      });
      this.querySelectorAll('[data-qty]').forEach((step) => {
        const qty = Number(step.dataset.qty);
        step.classList.toggle('is-on', n >= qty);
        step.classList.toggle('is-current', qty === current);
      });
      const fill = this.querySelector('[data-rr-ladder-fill]');
      if (fill) fill.style.width = `${Math.min(100, (n / top) * 100)}%`;
      // en el ticker el mensaje va repetido: se cambian todas las copias
      const text = n <= 4 ? this.getAttribute(`data-msg-${n}`) : this.dataset.msgMax.replace('__N__', n);
      this.querySelectorAll('[data-rr-ladder-msg]').forEach((msg) => {
        msg.textContent = text;
      });
    }
  }

  customElements.define('rr-stack-ladder', RRStackLadder);
})();
